import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "btn-group-vertical d-flex",
  role: "group"
}
const _hoisted_2 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_3 = {
  key: 0,
  class: "fa fa-circle-thin",
  "aria-hidden": "true"
}
const _hoisted_4 = {
  key: 1,
  class: "badge badge-pill badge-light text-primary"
}
const _hoisted_5 = { class: "dropdown-menu" }
const _hoisted_6 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_7 = {
  key: 0,
  class: "fa fa-circle-thin",
  "aria-hidden": "true"
}
const _hoisted_8 = {
  key: 1,
  class: "badge badge-pill badge-light text-primary"
}
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = ["value"]

import { computed } from 'vue'

    /* ---------------- props / emits ---------------- */

    
export default /*@__PURE__*/_defineComponent({
  __name: 'PanelistSurveyVoteEditorPc',
  props: {
    propValue: {},
    propComment: {},
    propFirstAlternativeName: {},
    propSecondAlternativeName: {}
  },
  emits: ["update-value", "update-comment"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    /* ---------------- derived ---------------- */

    const value = computed<number | null>(() => props.propValue ?? null)
    const comment = computed<string | null>(() => props.propComment ?? null)

    const firstAlternativeName = computed(() => props.propFirstAlternativeName)
    const secondAlternativeName = computed(() => props.propSecondAlternativeName)

    const FirstItemSelected = computed(() => value.value != null && value.value > 1.0)
    const SecondItemSelected = computed(() => value.value != null && value.value < 1.0)
    const EqualitySelected = computed(() => value.value === 1.0)

    /* ---------------- labels ---------------- */

    const ScaleLabel = computed<string | null>(() =>
    {
        if (value.value == null) return null

        let v = value.value
        if (v < 1.0)
        {
            v = Math.round((1 / v) * 100) / 100
        }

        switch (v)
        {
            case 2.0: return 'Weakly'
            case 3.0: return 'Moderately'
            case 4.0: return 'Moderately +'
            case 5.0: return 'Strongly'
            case 6.0: return 'Strongly +'
            case 7.0: return 'Very Strongly'
            case 8.0: return 'Very Strongly +'
            case 9.0: return 'Extremely'
            default: return ''
        }
    })

    /* ---------------- actions ---------------- */

    function updateValue(v: number | null)
    {
        emit('update-value', v)
    }

    function updateComment(c: string)
    {
        emit('update-comment', c)
    }

    function SetEqualCommand()
    {
        if (EqualitySelected.value === true)
        {
            updateValue(null)
        } else
        {
            updateValue(1.0)
        }
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          "data-toggle": "dropdown",
          class: _normalizeClass(["btn text-left", FirstItemSelected.value === true ? 'btn-primary' : 'btn-outline-secondary']),
          style: {"padding":"0.75rem 1.25rem"}
        }, [
          (FirstItemSelected.value === true)
            ? (_openBlock(), _createElementBlock("i", _hoisted_3))
            : _createCommentVNode("v-if", true),
          (FirstItemSelected.value === true)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _cache[19] || (_cache[19] = _createElementVNode("i", {
                  class: "fa fa-check",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */)),
                _createTextVNode(" " + _toDisplayString(ScaleLabel.value), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _createTextVNode(" " + _toDisplayString(firstAlternativeName.value), 1 /* TEXT */)
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_5, [
          _cache[22] || (_cache[22] = _createElementVNode("h4", { class: "dropdown-header" }, "How strong is your preference?", -1 /* CACHED */)),
          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (updateValue(2)))
          }, "Weak"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (updateValue(3)))
          }, "Moderate"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (updateValue(4)))
          }, "Moderate +"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (updateValue(5)))
          }, "Strong"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (updateValue(6)))
          }, "Strong +"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (updateValue(7)))
          }, "Very strong"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (updateValue(8)))
          }, "Very strong +"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (updateValue(9)))
          }, "Extreme"),
          (FirstItemSelected.value === true)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (updateValue(null)))
                }, [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("i", {
                    class: "fa fa-times text-danger",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" Clear ", -1 /* CACHED */)
                ]))])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        onClick: SetEqualCommand,
        class: _normalizeClass(["btn text-left", EqualitySelected.value === true ? 'btn-primary' : 'btn-outline-secondary']),
        style: {"padding":"0.75rem 1.25rem"}
      }, [
        _createElementVNode("i", {
          class: _normalizeClass(["fa", EqualitySelected.value === true ? 'fa-check-circle' : 'fa-circle-thin'])
        }, null, 2 /* CLASS */),
        _cache[24] || (_cache[24] = _createTextVNode(" Equally preferred ", -1 /* CACHED */))
      ], 2 /* CLASS */),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["btn text-left", SecondItemSelected.value === true ? 'btn-primary' : 'btn-outline-secondary']),
          "data-toggle": "dropdown",
          style: {"padding":"0.75rem 1.25rem"}
        }, [
          (SecondItemSelected.value === true)
            ? (_openBlock(), _createElementBlock("i", _hoisted_7))
            : _createCommentVNode("v-if", true),
          (SecondItemSelected.value === true)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                _cache[25] || (_cache[25] = _createElementVNode("i", {
                  class: "fa fa-check",
                  "aria-hidden": "true"
                }, null, -1 /* CACHED */)),
                _createTextVNode(" " + _toDisplayString(ScaleLabel.value), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _createTextVNode(" " + _toDisplayString(secondAlternativeName.value), 1 /* TEXT */)
        ], 2 /* CLASS */),
        _createElementVNode("div", _hoisted_9, [
          _cache[28] || (_cache[28] = _createElementVNode("h4", { class: "dropdown-header" }, "How strong is your preference?", -1 /* CACHED */)),
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (updateValue(1.0/2.0)))
          }, "Weak"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[10] || (_cache[10] = ($event: any) => (updateValue(1.0/3.0)))
          }, "Moderate"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (updateValue(1.0/4.0)))
          }, "Moderate +"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[12] || (_cache[12] = ($event: any) => (updateValue(1.0/5.0)))
          }, "Strong"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (updateValue(1.0/6.0)))
          }, "Strong +"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (updateValue(1.0/7.0)))
          }, "Very strong"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[15] || (_cache[15] = ($event: any) => (updateValue(1.0/8.0)))
          }, "Very strong +"),
          _createElementVNode("a", {
            class: "dropdown-item",
            onClick: _cache[16] || (_cache[16] = ($event: any) => (updateValue(1.0/9.0)))
          }, "Extreme"),
          (SecondItemSelected.value === true)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1 /* CACHED */)),
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[17] || (_cache[17] = ($event: any) => (updateValue(null)))
                }, [...(_cache[26] || (_cache[26] = [
                  _createElementVNode("i", {
                    class: "fa fa-times text-danger",
                    "aria-hidden": "true"
                  }, null, -1 /* CACHED */),
                  _createTextVNode(" Clear ", -1 /* CACHED */)
                ]))])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true)
        ])
      ])
    ]),
    _createElementVNode("textarea", {
      rows: "3",
      value: comment.value,
      onInput: _cache[18] || (_cache[18] = ($event: any) => (updateComment($event.target.value))),
      class: "form-control my-3",
      placeholder: "Comment..."
    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_10)
  ]))
}
}

})